import { Button } from '@components/Button';
import { IconExternalLink } from '@components/Icon';
import { Link, RouterLink } from '@components/Link';
import Loader from '@components/Loader';
import Modal from '@components/Modal';
import { StackSmall } from '@components/Stack';
import { Text } from '@components/Text';
import { useFetcher } from '@services/useFetcher';
import useAuth from '@State/Auth/useAuth';
import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { ButtonWrapper, ErrorBox, SignOutWrapper } from './wrapper';

export const TermsAgreementModal = () => {
  const { fetchWithToken } = useFetcher();
  const { signOut } = useAuth();
  const { t } = useTranslation();

  const [modal, setModal] = useState(true);
  const [isLoading, setIsLoading] = useState(false);
  const [hasError, setHasError] = useState(false);

  const handleClick = () => {
    setIsLoading(true);
    setHasError(false);

    const url = `${import.meta.env.VITE_CUSTOMER_PORTAL_API || ''}/profile/terms`;
    fetchWithToken(url, { method: 'PUT', body: { version: '1.0' } })
      .then(() => {
        setModal(false);

        // Remove old token to force refetch
        sessionStorage.removeItem('kc_token');
      })
      // Modalen går inte att stänga på annat sätt, så ett fel måste visas
      // och knappen återställas. Annars står användaren kvar med en låst
      // knapp och en spinner utan slut.
      .catch(() => setHasError(true))
      .finally(() => setIsLoading(false));
  };

  return modal ? (
    <Modal title={t('terms_agreement_modal_title')} overlay>
      <StackSmall>
        <Text>{t('terms_agreement_modal_text')}</Text>
      </StackSmall>

      <StackSmall>
        <RouterLink
          title={t('terms_agreement_modal_heading')}
          target="_blank"
          rel="noopener noreferrer"
          to="/terms-of-use"
        >
          {t('terms_agreement_modal_read_more')} <IconExternalLink display="inline-block" />
        </RouterLink>
      </StackSmall>

      {hasError && (
        <ErrorBox role="alert">
          <strong>{t('terms_agreement_modal_error_title')}</strong>
          <span>{t('terms_agreement_modal_error_text')}</span>
        </ErrorBox>
      )}

      <ButtonWrapper>
        <Button onClick={() => handleClick()} disabled={isLoading}>
          {t(hasError ? 'terms_agreement_modal_retry' : 'terms_agreement_modal_button_text')}
          {isLoading && <Loader style={{ marginLeft: '10px' }} inlineBlock />}
        </Button>
      </ButtonWrapper>

      <SignOutWrapper>
        <Link as="button" type="button" onClick={signOut}>
          {t('terms_agreement_modal_sign_out')}
        </Link>
      </SignOutWrapper>
    </Modal>
  ) : null;
};
